import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

export const PanelFooter: FC = () => {
  const { t } = useTranslate();
  return (
    <Stack sx={{ px: 2, pb: 2 }}>
      <DashboardTypography variant="caption" vibe="text-neutral-quiet" sx={{ textAlign: "center" }}>
        {t("dashboard", "assistant.widget.disclaimer")}
      </DashboardTypography>
    </Stack>
  );
};
